module.exports = __webpack_public_path__ + "static/media/RightArrow.1f8c94af.svg";